
    import {
        defineComponent,
    } from 'vue';
    import useFilterSelected from '@ve/components/filters/common/use/useFilterSelected';
    import CheckBoxInput from '@ve/components/inputs/CheckBoxInput.vue';
    import Tooltip from '@ve/components/tooltip/Tooltip.vue';
    import { ConfirmationTypeInfo, ConfirmationType } from '@entities/confirmationType'

    export default defineComponent({
        name: 'warranted-filter',
        components: {
            CheckBoxInput,
            ConfirmationTypeInfo,
            Tooltip,
        },
        props: {
            selected: {
                type: Boolean,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, ctx) {
            return {
                ConfirmationType,
                ...useFilterSelected(props, ctx),
            };
        },
    });
